module.exports = __webpack_public_path__ + "static/fonts/Fact-CondensedBlack.91d1b6c.woff2";